import produce from 'immer';
import {
    SET_ADD_TO_CART_FEEDBACK_ITEMS,
    SET_ADD_TO_CART_FEEDBACK_VOUCHER,
    SET_ADD_TO_CART_FEEDBACK_COMBINED_WITH_ITEMS,
    SET_IS_ADD_TO_CART_FEEDBACK_VISIBLE,
    SET_ADD_TO_CART_FEEDBACK_CURRENCY,
    SET_CURRENT_UPSELL_ITEM,
    SET_IS_UPSELL_ITEM_SIZES_VISIBLE,
    SET_WIDGET_ID
} from '../actions/constants';

const initialState = {
    voucher: null,
    currency: {},
    addedItems: [],
    combinedWithItems: [],
    isVisible: false,
    currentUpsellItem: {},
    isSizesVisible: false,
    widgetId: null
};

const addToCartFeedback = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_ADD_TO_CART_FEEDBACK_ITEMS: {
            state.addedItems = payload;
            break;
        }

        case SET_ADD_TO_CART_FEEDBACK_VOUCHER: {
            state.voucher = payload;
            break;
        }

        case SET_ADD_TO_CART_FEEDBACK_COMBINED_WITH_ITEMS: {
            state.combinedWithItems = payload;
            break;
        }

        case SET_IS_ADD_TO_CART_FEEDBACK_VISIBLE: {
            state.isVisible = payload;
            break;
        }

        case SET_ADD_TO_CART_FEEDBACK_CURRENCY: {
            state.currency = payload;
            break;
        }

        case SET_CURRENT_UPSELL_ITEM: {
            state.currentUpsellItem = payload;
            break;
        }

        case SET_IS_UPSELL_ITEM_SIZES_VISIBLE: {
            state.isSizesVisible = payload;
            break;
        }

        case SET_WIDGET_ID: {
            state.widgetId = payload;
            break;
        }
        // skip default
    }
}, initialState);

export default addToCartFeedback;
